"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.62 12.27H12L9.67 1.62a.954.954 0 0 0-.93-.75H7.26a.97.97 0 0 0-.93.75L4 12.27h-.62c-.28 0-.5.22-.5.5v2.1h1v-1.6h8.24v.6H4.36v1h8.26c.28 0 .5-.22.5-.5v-1.6c0-.28-.22-.5-.5-.5Zm-2.48-3.84h-4.3l.55-2.56h3.18l.56 2.56h.01ZM7.26 1.87l1.44-.04.67 3.05H6.62l.65-3.01h-.01ZM5.63 9.44h4.73l.62 2.84H5.02l.61-2.84Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.297 18.892h-1.162L14.415 1.89A1.283 1.283 0 0 0 13.17.892h-2.34c-.593 0-1.118.42-1.245 1.005L5.865 18.9H4.702a.567.567 0 0 0-.562.563v3.09h1.125v-2.536h13.47v1.396H6.247v1.125h13.05a.567.567 0 0 0 .563-.563v-2.52a.567.567 0 0 0-.563-.563ZM15.66 12.84H8.34l.982-4.493h5.355l.983 4.493ZM10.68 2.13a.153.153 0 0 1 .15-.12h2.34c.067 0 .127.045.15.12l1.11 5.085H9.57l1.11-5.085ZM8.092 13.965h7.815l1.08 4.927H7.02l1.08-4.927h-.008Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.73 25.19h-1.55L19.22 2.52a1.71 1.71 0 0 0-1.66-1.33h-3.12c-.79 0-1.49.56-1.66 1.34L7.82 25.2H6.27c-.41 0-.75.34-.75.75v4.12h1.5v-3.38h17.96v1.86H8.33v1.5h17.4c.41 0 .75-.34.75-.75v-3.36c0-.41-.34-.75-.75-.75Zm-4.85-8.07h-9.76l1.31-5.99h7.14l1.31 5.99ZM14.24 2.84c.02-.09.1-.16.2-.16h3.12c.09 0 .17.06.2.16l1.48 6.78h-6.48l1.48-6.78Zm-3.45 15.78h10.42l1.44 6.57H9.36l1.44-6.57h-.01Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M39.262 39.075h-2.625L28.814 3.33a2.439 2.439 0 0 0-2.37-1.905h-4.897c-1.133 0-2.13.803-2.37 1.905l-7.822 35.745H8.729a.938.938 0 0 0-.937.938v6.232h1.875V40.95h28.65v3.39H11.969v1.875h27.285c.518 0 .938-.42.938-.937v-5.265a.938.938 0 0 0-.938-.938h.008Zm-7.313-12.66h-15.9l2.16-9.877h11.58l2.16 9.877ZM21.016 3.735a.547.547 0 0 1 .54-.435h4.897c.262 0 .48.18.54.435l2.392 10.928H18.622l2.393-10.928ZM15.637 28.29h16.725l2.362 10.785H13.282l2.363-10.785h-.008Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M52.35 52.1h-3.5L38.42 4.44a3.252 3.252 0 0 0-3.16-2.54h-6.53c-1.51 0-2.84 1.07-3.16 2.54L15.14 52.1h-3.5c-.69 0-1.25.56-1.25 1.25v8.31h2.5V54.6h38.2v4.52H15.96v2.5h36.38c.69 0 1.25-.56 1.25-1.25v-7.02c0-.69-.56-1.25-1.25-1.25h.01ZM42.6 35.22H21.4l2.88-13.17h15.44l2.88 13.17ZM28.02 4.98a.73.73 0 0 1 .72-.58h6.53c.35 0 .64.24.72.58l3.19 14.57H24.83l3.19-14.57Zm-7.17 32.74h22.3L46.3 52.1H17.71l3.15-14.38h-.01Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconCautionCone = function IconCautionCone(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Caution Cone' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "CautionCone"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconCautionCone.sizes = [16, 24, 32, 48, 64];
IconCautionCone.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconCautionCone;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/coverage-options/CautionCone.js
// module id = 1979
// module chunks = 0